import { Play, Sparkles } from "lucide-react";
import { MAX_TOTAL } from "../color";
import { copy } from "../copy";

export function Hero({
  best,
  onStart,
}: {
  best: number;
  onStart: () => void;
}) {
  return (
    <header className="hero">
      <div>
        <p className="eyebrow">
          <Sparkles size={16} /> {copy.eyebrow}
        </p>
        <h1>{copy.brand}</h1>
        <p>{copy.title}</p>
        <span>{copy.subtitle}</span>
      </div>
      <div className="hero-actions">
        <strong>
          0
          <small>/{MAX_TOTAL}</small>
        </strong>
        <button className="primary" onClick={onStart}>
          <Play size={18} />
          {copy.start}
        </button>
        <span>
          {copy.bestScore} {best}
          {copy.point}
        </span>
      </div>
    </header>
  );
}
